import * as actions from 'app/actions/issue';
import http from 'app/services/http';

export const userReducer = (
    state = {
        items: [],
        typeItems: [],
        transportItem: null,
        selectedItem: null,
        sortSelectedItem: { name: config.issueColumns[1].name, order: config.issueColumns[1].order },
        searchValue: '',
    },
    action
) => {
    switch (action.type) {
        case 'ISSUE_SET_ITEMS': {
            const { items } = action.payload;

            return {
                ...state,
                items: items,
            };
        }
        case 'ISSUE_SET_SELECTED_ITEM': {
            const { data } = action.payload;

            return {
                ...state,
                selectedItem: data ? data : null,
            };
        }
        case 'ISSUE_SET_SEARCH_VALUE': {
            const { value } = action.payload;

            return {
                ...state,
                searchValue: value,
            };
        }
        case 'ISSUE_SET_SORT_SELECTED_ITEM': {
            const { data } = action.payload;

            return {
                ...state,
                sortSelectedItem: {
                    name: data.name,
                    order: state.sortSelectedItem.name !== data.name ? data.order : state.sortSelectedItem.order === 'ASC' ? 'DESC' : 'ASC',
                },
            };
        }
        case 'ISSUE_ADD_ITEM': {
            const { data } = action.payload;

            return {
                ...state,
                items: [...state.items, data],
                selectedItem: data,
            };
        }
        case 'ISSUE_UPDATE_ITEM': {
            const { data } = action.payload;

            return {
                ...state,
                selectedItem: data,
                items: state.items.map((value) => {
                    if (value.id !== state.selectedItem.id) {
                        return value;
                    }

                    return data;
                }),
            };
        }
        case 'ISSUE_SET_TRANSPORT_ITEM': {
            const { data } = action.payload;

            return {
                ...state,
                transportItem: data ? { ...state.transportItem, ...data } : null,
            };
        }
        case 'ISSUE_SET_TYPE_ITEMS': {
            const { items } = action.payload;

            return {
                ...state,
                typeItems: items,
            };
        }
        default:
            return state;
    }
};

export function issueLoad() {
    return async function issueLoadThunk(dispatch) {
        const { data } = await http.get(`/issue`);
        return dispatch(actions.setItems(data));
    };
}

export function issueTypeFormLoad() {
    return async function issueTypeFormLoadThunk(dispatch) {
        const { data } = await http.get('/issue/type');
        return dispatch(actions.setTypeItems(data));
    };
}

export function issueCreate(params) {
    return async function issueCreateThunk(dispatch) {
        const data = await http.post('/issue', params);
        return dispatch(actions.addItem(data));
    };
}

export function issueStatusUpdate(id, params) {
    return async function issueStatusUpdateThunk(dispatch) {
        const { data } = await http.put(`/issue/${id}`, params);
        return dispatch(actions.updateItem(data));
    };
}

export default userReducer;
